import quilt from "../assets/images/quilt-full.svg";
import quilt_dark from "../assets/images/quilt-full-dark.svg";
import face2 from "../assets/images/Ayomide Face Card 2.jpg";

function Introduction() {
  return (
    <>
      <h1 className="u-vis-hidden">A brief introduction</h1>
      <div className="home-banner">
        <div className="l-contain l-contain--flush l-grid l-grid--flush | home-banner__content">
          <div className="h1 home-banner__tagline">
            <img src={face2} alt="Ayomide face card 1" className="facecard1" />

            <p>
              Enchantée! I'm Ayomide , your neighbourhood friendly lawyer and
              product/project manager. Welcome to my portfolio page, where you
              get to understand more about me and what I do.
            </p>
          </div>
          {/* <!-- Switching out image like this instead of using prefers-color-scheme in media attr because I'm offering JS-based theme switching too --> */}
          <picture className="quilt quilt--light">
            <source
              srcSet="https://d33wubrfki0l68.cloudfront.net/246935ea63e0d36a1b026498a90e6bcab3e5f061/cb818/assets/images/quilt-full.svg"
              media="(min-width: 50em)"
            />
            <img
              src={quilt}
              alt="Geometric shapes arranged like quilt blocks, in dark forest green, an orangey red, and varying tones of pink and beige."
            />
          </picture>
          <picture className="quilt quilt--dark">
            <source
              srcSet="https://d33wubrfki0l68.cloudfront.net/e574e387cd575459ec73c150cbd6c44e356519b3/ba379/assets/images/quilt-full-dark.svg"
              media="(min-width: 50em)"
            />
            <img
              src={quilt_dark}
              alt="Geometric shapes arranged like quilt blocks, in dark blues and purples, with a hint of lilac."
            />
          </picture>
        </div>
      </div>
    </>
  );
}
export default Introduction;
